import { useCallback } from 'react';

import { uniq } from 'lodash';
import { Apollo } from 'src/gql/generated';
import type { MessageSuggestionStatus } from 'src/gql/generated/apollo-types';

/**
 * Update the suggestion status in the database and the chat state.
 */
export function useUpdateSuggestionStatusInChat() {
  const [updateAgentMessageSuggestions] = Apollo.useUpdateAgentMessageSuggestionsMutation();
  const updateSuggestionStatusInChat = useCallback(
    ({
      groupIds,
      messageId,
      status,
    }: {
      groupIds: string[];
      messageId: string;
      status: MessageSuggestionStatus;
    }) => {
      return updateAgentMessageSuggestions({
        variables: {
          input: {
            groupIds: uniq(groupIds),
            messageId,
            status,
          },
        },
      });
    },
    [updateAgentMessageSuggestions]
  );
  return { updateSuggestionStatusInChat };
}
